import React from 'react';
import { Link } from 'react-router-dom';
import SectionHeader from '../components/SectionHeader';
import Popover from '../components/Popover';
import { sampleProducts } from '../data/products';

export default function Home() {
  return (
    <div className="page-wrapper">
      <div className="container">
        {/* Intro Card */}
        <div className="card" style={{ marginBottom: '2rem' }}>
          <div className="card-header">
            <h4>Scott Mason — Full Stack Developer &amp; Data Scientist</h4>
          </div>
          <div className="card-body">
            <p>This site contains some of the work that Scott has done over the past several years.</p>
            <p>The user experience is designed to be very functional, yet simple and intuitive.</p>
          </div>
        </div>

        {/* Technologies Section */}
        <div className="clearfix info-block">
          <img
            alt="eCommerce"
            src="/images/projects/ecommerce.jpg"
            className="float-img-right"
            style={{ height: 214, width: 355 }}
            onError={e => { e.target.style.display = 'none'; }}
          />
          <p>Some of the technologies that Scott works with as a <u>developer</u> are:</p>
          <ul>
            <li>
              <strong><u>.Net core</u></strong> for smaller applications running on Windows, Linux, and Apple computers
            </li>
            <li>
              .Net <strong><u>Entity Framework</u></strong> for large scale enterprise applications
            </li>
            <li>
              Web development using <strong>MVC</strong> and{' '}
              <Popover
                label="MVVM (Model-View-ViewModel)"
                title="MVVM"
                content="MVVM is a software architectural pattern that separates the application into three components: the Model (data and business logic), the View (user interface), and the ViewModel."
              />
            </li>
            <li>
              Leveraging{' '}
              <Popover
                label="Dependency Injection"
                title="Dependency Injection"
                content="A design pattern that allows objects to receive their dependencies rather than creating them, promoting loose coupling and easier testing."
              />{' '}
              to decouple and separate concerns, testability, and reusability
            </li>
            <li>
              Developing{' '}
              <Popover
                label="RESTful APIs"
                title="RESTful APIs"
                content="Used in networked applications, allowing communication between systems via standard HTTP methods for creating, reading, updating, and deleting resources."
              />
            </li>
            <li>UI/UX front-end development with Angular or Next.JS to provide user friendly experiences</li>
            <li>Scott is a <strong>Certified SAP Consultant</strong> and has helped implement Enterprise ERP implementations</li>
          </ul>
        </div>

        <div className="info-block">
          <p>Scott has an innovative approach to solving problems; He brings unique solutions, functionality, reliability, manageability, and performance as major benefits to management as well as customers.</p>
        </div>

        <ul style={{ marginBottom: '1.5rem' }}>
          <li>Bachelor's degree in Business Administration from the University of Oregon</li>
          <li>Scott's experience above demonstrates a self-starter approach with the ability to multi-task</li>
          <li>Experience with <strong>Nike</strong>, <strong>Oakley</strong>, <strong>Adidas</strong>, <strong>Hyundai</strong>, and others gives him a unique perspective in working for some of the best run innovators in the world</li>
          <li>He has direct experience in Fortune 500 companies <strong>ERP</strong> Sales and Distribution and Financial systems</li>
          <li>Scott is an excellent writer and has excellent documentation skills</li>
          <li>Scott has strong written and oral communication skills, with an ability to convey a vision of the organization's strategic future to all stakeholders</li>
        </ul>

        <div className="clearfix info-block">
          <img
            alt="Azure Analytics"
            src="/images/projects/azure-analytics.png"
            className="float-img-right"
            style={{ height: 214, width: 355 }}
            onError={e => { e.target.style.display = 'none'; }}
          />
          <p>Scott started his career:</p>
          <ul>
            <li>As a DBA</li>
            <li>Then progressed to a Data Architect</li>
            <li>Then began developing middle ware</li>
            <li>Then began to develop the Front End with HTML, Javascript, <strong>Angular</strong>, <strong>Next.JS</strong>, and frameworks</li>
            <li>Then began to Architect large solutions across Global Enterprises</li>
            <li>Then progressed to designing and developing AI/Data Science models</li>
          </ul>
        </div>

        <div className="info-block">
          <p>Scott continues to stay involved as a Full Stack Developer and has created this website.</p>
          <p>This site is maintained by Scott using <strong>Microsoft's Visual Studio</strong> and <strong>Git</strong> version control</p>
        </div>

        <div className="info-block">
          <p><strong>Certifications:</strong></p>
          <ul>
            <li>Certification: <strong><u>Stanford University</u></strong> — Machine Learning — datamining, and statistical pattern recognition. Supervised learning (parametric/non-parametric algorithms, support vector machines, kernels, neural networks) using MatLab &amp; the R programming language</li>
            <li>Certification: <strong><u>Data Science using Python</u></strong> by <strong>University of Michigan</strong> on Coursera</li>
            <li>Certification: <strong><u>Advanced Scrum Master</u></strong> — Servant Leadership: Principles and Practices</li>
            <li>PMP Certified Project Manager PMI</li>
            <li>Certification: Senior Project Risk Management – 4pm/Hampton Group, Inc.</li>
          </ul>
        </div>

        {/* eCommerce section */}
        <SectionHeader title="Scott's sample eCommerce Site — Click on 'Details' below and sample how to order a product in style." />

        <div className="products-grid">
          {sampleProducts.map(product => (
            <div className="product-card" key={product.id}>
              {product.images && product.images.length > 0 ? (
                <img
                  src={product.images[0].imageUrl}
                  alt={product.title}
                  onError={e => { e.target.src = 'https://placehold.co/500x600/png'; }}
                />
              ) : (
                <img src="https://placehold.co/500x600/png" alt={product.title} />
              )}
              <div className="product-card-body">
                <p className="product-title">{product.title}</p>
                <p className="product-author">by <b>{product.author}</b></p>
                <div className="product-price">
                  <p style={{ marginBottom: '0.2rem' }}>List Price: <span className="list-price">${product.listPrice.toFixed(2)}</span></p>
                  <p>As low as: <span className="as-low">${product.price100.toFixed(2)}</span></p>
                </div>
              </div>
              <div className="product-card-footer">
                <Link to={`/products/${product.id}`} className="btn btn-primary btn-block">Details</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
